module.exports = __webpack_public_path__ + "img/LI.c08ea9f0.svg";